import { useFileDetailSectionQuery } from 'generated/graphql';
import { DateTime } from 'luxon';
import React from 'react';

export interface IData {
  id: string;
  title: string;
  fileSize: string;
  createdTimestamp: DateTime;
  updatedTimestamp: DateTime;
  uploadedBy: string;
  url: string;
  apiFileId: string;
  fileType: string;

}



export function useQuery(id: string) {
  const tuple = useFileDetailSectionQuery({
    variables: {
      id
    },
    skip: id === ''
  });

  return React.useMemo(
    () => {
      const data: IData = {
        id: tuple.data?.document?.id ?? '',
        title: tuple.data?.document?.title ?? '',
        fileSize: tuple.data?.document?.apiFile.formattedFileSize ?? '',
        createdTimestamp: tuple.data?.document?.createdTimestamp ?? DateTime.now(),
        updatedTimestamp: tuple.data?.document?.updatedTimestamp ?? DateTime.now(),
        uploadedBy: tuple.data?.document?.uploadedBy?.fullName ?? '',
        apiFileId: tuple.data?.document?.apiFile.id ?? '',
        fileType: tuple.data?.document?.apiFile.mimeType ?? '',
        url: tuple.data?.document?.apiFile.url ?? ''
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}


